import { AppleNotesStepsMap } from "@/components/onboarding/components/WelcomeWizard/steps/import/AppleNotesSteps";
import { ObsidianStepsMap } from "@/components/onboarding/components/WelcomeWizard/steps/import/ObsidianSteps";
import { OtherAppsStepsMap } from "@/components/onboarding/components/WelcomeWizard/steps/import/OtherAppsSteps";
import { PostImportStepsMap } from "@/components/onboarding/components/WelcomeWizard/steps/post-import";
import type {
  StepMap,
  StepGroup,
  AppId,
} from "@/components/onboarding/components/WelcomeWizard/WelcomeWizard.types";
import { AppSelectionStep } from "@/components/onboarding/components/WelcomeWizard/steps/import/AppSelectionStep";
import { SkipConfirmationStep } from "@/components/onboarding/components/WelcomeWizard/steps/import/SkipConfirmationStep";
import { IcpRfiStepsMap } from "@/components/onboarding/components/WelcomeWizard/steps/onboarding/IcpRfiStep";
import { ReferrerStepsMap } from "@/components/onboarding/components/WelcomeWizard/steps/onboarding/ReferrerStep";
import { NotesApps } from "@/components/onboarding/components/WelcomeWizard/steps/import/ImportSteps.config";

// Each group corresponds to an onboarding stage that can be _dismissed_ through the API
export const StepGroups: Record<string, StepGroup> = {
  // ICP RFI = "ideal customer profile request for information"
  ICP_RFI: {
    id: "onboarding",
    title: "Welcome to Mem",
    steps: ["user-profile", "referrer"],
    showTabs: false,
  },
  IMPORT: {
    id: "import",
    title: "Import Your Notes",
    steps: [
      "app-selection",
      "skip-confirmation",
      "apple-notes-1",
      "apple-notes-2",
      "apple-notes-3",
      "obsidian-1",
      "obsidian-2",
      "other-apps-1",
    ],
    showTabs: true,
    tabConfig: { tabs: NotesApps },
  },
  POST_IMPORT: {
    id: "post-import",
    title: "Post Import",
    steps: ["download-apps", "intro-video"],
    showTabs: false,
  },
} as const;

export const Steps: StepMap = {
  ...IcpRfiStepsMap,
  ...ReferrerStepsMap,
  ...PostImportStepsMap,
  "app-selection": {
    id: "app-selection",
    group: "import-cta",
    render: ({
      context,
      onUpdateContext,
      onNavToStep,
      selectedAppId,
      customAppName,
      onSetSelectedApp,
      onSetCustomAppName,
    }) => (
      <AppSelectionStep
        selectedAppId={selectedAppId || context.selectedAppId || null}
        customAppName={customAppName || context.customAppName || ""}
        onAppSelect={(appId: AppId) => {
          onSetSelectedApp?.(appId);
          onUpdateContext({ selectedAppId: appId });
        }}
        onCustomAppNameChange={(name: string) => {
          onSetCustomAppName?.(name);
          onUpdateContext({ customAppName: name });
        }}
        onNavToStep={onNavToStep}
      />
    ),
  },
  "skip-confirmation": {
    id: "skip-confirmation",
    group: "import-cta",
    render: props => <SkipConfirmationStep {...props} />,
  },
  ...AppleNotesStepsMap,
  ...ObsidianStepsMap,
  ...OtherAppsStepsMap,
} as const;
